import { make } from 'vuex-pathify';
import { filter, keyBy, keys, shuffle, sortBy, values } from 'lodash';

const tips = keyBy(
    [
        {
            id: 1,
            tip: 'Talk about what you are comfortable with (sexual boundaries) up front.',
            info:
                'With a one night stand, start talking about sexual boundaries at the club before you leave together so you know you’re on the same page. With a client, you can ask them what they want and negotiate the price beforehand.',
            matched: false
        },
        {
            id: 2,
            tip: 'Use condoms for everything, including oral sex.',
            info: 'That’s right, there are STI risks with oral sex. Most people will be willing to accept a covered blow job over no blow job at all!',
            matched: false
        },
        {
            id: 3,
            tip: 'Know your limits with drugs and alcohol.',
            info:
                'We’re more likely not to stick to our sexual boundaries when we are high or drunk. Know how much your body can handle, set a limit for the night, and stick to it.',
            matched: false
        },
        {
            id: 4,
            tip: 'Be mindful about wearing anything around your neck. Necklaces, scarves, key chains, etc.',
            info: 'It’s scary to think about, but anything you wear around your neck can be used against you in the case of an attack.',
            matched: false
        },
        {
            id: 5,
            tip: 'Get tested for HIV and STIs often (every 3 to 6 months).',
            info:
                'The sooner you treat HIV or another STI, the less damage it does to your body. Keep in mind there are certain STIs that may show no signs or symptoms, and the only way to detect them is by getting tested, so testing more often is a good idea.  For more information about testing check out: <a href="https://www.healthline.com/health/healthy-sex/free-sti-testing" target="_blank">www.healthline.com/health/healthy-sex/free-sti-testing</a>',
            matched: false
        },
        {
            id: 6,
            tip: 'Speak up and reach out if you feel vulnerable.',
            info:
                'If no one you know is around, pretend they are! Call out to the nearest passerby as if you know them. This lets the partner know that you have been witnessed leaving with them. Or call your own number and leave a message about where you are and when you’ll be home to give the impression that others know where you are.',
            matched: false
        },
        {
            id: 7,
            tip: 'Let a friend know where you are and what time you’re supposed to be done.',
            info:
                'Call a friend and leave a message with a description of who you’re with, where you are, or send a photo of the person and/or describe identifiable characteristics (e.g., tattoos, scars, etc.), or take a photo or text of the license plate if the person is in a vehicle, and when you think you’ll be done, so another person knows your whereabouts, which can add to your overall safety.',
            matched: false
        },
        {
            id: 8,
            tip: 'Share information with other people. Ask others about their bad experiences, too.',
            info:
                'If you had a bad experience with a date, let your friends know. In the context of sex work, this may help you and others to avoid clients that may be threatening, don’t wanna pay, etc.',
            matched: false
        },
        {
            id: 9,
            tip: 'Don’t leave drinks unattended or accept drinks you didn’t watch being made.',
            info:
                'While it is messed up, people do slip drugs into people’s drinks without them knowing. There are many substances (e.g., GHB Ketamine, Ecstasy, Rohypnol, etc.) that can cause you to pass out or lose control and predators can use them to gain control over you. If you leave your drink unattended, get a new one. Don’t accept drinks that you didn’t open or that you didn’t watch being made. If you need to go to the restroom or step away cover your drink with a napkin and give to the bartender to hold for you.',
            matched: false
        }
    ],
    'id'
);
const infoOrder = sortBy(keys(tips), k => parseInt(k));

const state = {
    title: 'Sex Work and One Night Stands',
    complete: false,
    sticker: {
        text: 'Girl in red dress dancing emoji',
        earned: false,
        image: require('@/assets/stickers/stickers_0008_dancer.png')
    },
    bonusSticker: false,
    trophy: false,
    tips,
    infoOrder
};
const getters = {
    ...make.getters(state),
    currentTip: state => {
        const remaining = shuffle(filter(values(state.tips), { matched: false })); // shuffle the remaining unmatched tips
        if (remaining && remaining.length) {
            return state.tips[remaining[0].id]; // pick from the top of the shuffled remaining pile
        }
        return null;
    }
};
const mutations = make.mutations(state);
const actions = make.actions(state);

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
